import { css } from 'emotion'
import { DANGER_COLOR } from '../../constants/styleConstants'

export const dangerColorStyles = css`
  color: ${DANGER_COLOR};
`
